"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Send = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M-1-1h16v16H-1z"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M.703 5.071L12.92.111c.778-.316 1.24.1 1.03.93l-3.039 12.06c-.21.83-.939 1.11-1.63.627l-3.166-2.216-2.41 2.088c-.638.555-1.156.31-1.156-.548V8.577L.432 6.67c-.629-.566-.507-1.282.271-1.598zm4.97 4.958l6.637-8.001-8.343 6.401 1.707 1.6z"
})));

var _default = Send;
exports.default = _default;